import React from 'react';
import { ScrollView, View, StyleSheet } from 'react-native';
import { Color, CommonProperties, CommonStyles } from '../styles';
import BaseText from './BaseText';

const WhiteBoardTextMsg = ({ text }) => {
  return (
    <View style={CommonStyles.flex1}>
      <ScrollView contentContainerStyle={styles.scrollViewContainer}>
        <View style={CommonStyles.px3}>
          <View style={styles.widgetContainer}>
            <View style={styles.rowButton}>
              <View style={styles.messageBoxHeading}>
                <BaseText style={[CommonStyles.h2, CommonStyles.ml2]}>{text}</BaseText>
              </View>
            </View>
          </View>
        </View>
      </ScrollView>
    </View>
  );
};

export default WhiteBoardTextMsg;

export const styles = StyleSheet.create({
  widgetContainer: {
    backgroundColor: Color.accent,
    ...CommonProperties.mt2,
    ...CommonProperties.mb3,
    ...CommonProperties.borderRadius,
    ...CommonProperties.shadow,
  },
  rowButton: {
    borderBottomWidth: 0.7,
    borderColor: Color.shadow,
    ...CommonProperties.p3,
  },
  messageBoxHeading: {
    flexDirection: 'row',
    textAlign: 'center',
  },
});
